import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoaderService {
  counter = 0;
  public displayLoader = new Subject<number>();

  showLoader(val: boolean) {
    if (!val && this.counter === 0) { return; }
    this.counter = val ? this.counter + 1 : this.counter - 1;
    this.displayLoader.next(this.counter);
  }
}

